import * as React from 'react';

type CartAddIconProps = React.SVGProps<SVGSVGElement>;

export const CartAddIcon: React.FC<CartAddIconProps> = React.memo(({ ...props }) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <defs>
                {/* Mask that removes a circular area from the cart */}
                <mask id='cart-badge-cut' maskUnits='userSpaceOnUse'>
                    {/* Start fully opaque */}
                    <rect x='0' y='0' width='24' height='24' fill='white' />
                    {/* Black = hole (transparent) */}
                    <circle cx='16.440117' cy='5.503408' r='5.4566698' fill='black' />
                </mask>
            </defs>

            {/* Cart with a circular "hole" where the badge will sit */}
            <g mask='url(#cart-badge-cut)'>
                <path d='M7.00488 7.99966V5.99966C7.00488 3.23824 9.24346 0.999664 12.0049 0.999664C14.7663 0.999664 17.0049 3.23824 17.0049 5.99966V7.99966H20.0049C20.5572 7.99966 21.0049 8.44738 21.0049 8.99966V20.9997C21.0049 21.5519 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.5519 3.00488 20.9997V8.99966C3.00488 8.44738 3.4526 7.99966 4.00488 7.99966H7.00488ZM7.00488 9.99966H5.00488V19.9997H19.0049V9.99966H17.0049V11.9997H15.0049V9.99966H9.00488V11.9997H7.00488V9.99966ZM9.00488 7.99966H15.0049V5.99966C15.0049 4.34281 13.6617 2.99966 12.0049 2.99966C10.348 2.99966 9.00488 4.34281 9.00488 5.99966V7.99966Z' />
            </g>

            {/* Plus badge (circle + plus) in currentColor, on top */}
            <path
                d='m 16.49854,10.035053 c -2.496307,0 -4.519961,-2.0236765 -4.519961,-4.5199605 0,-2.496307 2.023654,-4.51996102 4.519961,-4.51996102 2.496284,0 4.519961,2.02365402 4.519961,4.51996102 0,2.496284 -2.023677,4.5199605 -4.519961,4.5199605 z M 16.046544,5.0630965 h -1.807985 v 0.903992 h 1.807985 v 1.807984 h 0.903992 v -1.807984 h 1.807984 v -0.903992 h -1.807984 v -1.807985 h -0.903992 z'
                style={{ strokeWidth: 0.451996 }}
            />
        </svg>
    );
});
